"use client";

import { motion } from "framer-motion";
import { useState } from "react";
import ScrollContainer from "../../../Modals/filter modal/Scroll";
import EditModal from "./modals/EditModal";
import CustomInput from "../../../Modals/filter modal/Input";
import { useEffect } from "react";
import CargoService from "../../../services/Cargo";
import DeleteModal from "../../../Modals/delete modal/DeleteModal";
import DriverList from "./component/DriverList";
import { useDispatch } from "react-redux";
import { showToast } from "../../../redux/slices/toastSlice";
import { data, useNavigate } from "react-router";
import { timeAgo, gregorianToJalali } from "../../../utiels/functions/persianFormat";
import { formatNumberForDisplay } from "../../../utiels/functions/persianFormat";
import EmptyStateMyLoads from "../../../Modals/empty list/EmptyList";
import MyLoadsContentSkeleton from "./MyLoadsContentSkeleton";


export default function MyLoadsContent() {
  const dispatch = useDispatch()
  const navigate = useNavigate()


  const [expanded, setExpanded] = useState({});
  const [openEditModal, setOpenEditModal] = useState(false)
  const [title, setTitle] = useState(null)
  const [idCargo, setIdCargo] = useState(null)

  const [errors, setErrors] = useState({
    originState: false,
    originCity: false,
    destState: false,
    destCity: false,
    car: false,
    type: false,
    product: false,
    price: false,
    date: false,
    weight: false,
    desc: false,
  });

  const toggleExpand = (id) => {
    setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  //origin and state dataa
  const [loadingCity, setLoadingCity] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false)
  const [loadingBtn, setLoadingBtn] = useState(false)
  const [Data, SetOriginData] = useState([]);
  const [view, setView] = useState("load")
  const [isDeleting, setIsDeleting] = useState(false)
  const [typeItems, setTypeItems] = useState([{ value: "domestic", label: "داخلی" }, { value: "international", label: "خارجی" }])

  const [loading, setLoading] = useState(false);



  async function getAllCityAndState() {
    try {
      setLoadingCity(true);


      const res = await CargoService.getAllState();
      const states = res?.data?.data ?? [];


      const fetches = states.map((st) =>
        CargoService.getAllCity({ state_id: st._id })
          .then((r) => ({ state: st, citiesRes: r }))
          .catch((err) => {
            console.error("city fetch error for", st, err);
            return { state: st, citiesRes: null };
          })
      );

      const results = await Promise.all(fetches);


      const provincesWithCitiesArr = results.map(({ state, citiesRes }) => {
        const stateId = state?._id ?? state?.id ?? null;
        const stateName = state?.name ?? state?.title ?? String(stateId ?? "");

        const citiesArray = citiesRes?.data?.data ?? citiesRes?.data ?? citiesRes ?? [];


        const citiesNormalized = (Array.isArray(citiesArray) ? citiesArray : []).map((c) => {
          if (typeof c === "string") {
            return { name: c, value: c };
          }
          const cityId = c?._id ?? c?.id ?? c?.city_id ?? null;
          const cityName = c?.name ?? c?.title ?? c?.city_name ?? String(cityId ?? "");
          return { name: cityName, value: cityId ?? cityName };
        });

        return {

          label: stateName,
          value: stateId,
          subItems: citiesNormalized,
        };
      });

      SetOriginData(provincesWithCitiesArr);
    } catch (err) {
      console.error("getAllCityAndState error:", err);
      SetOriginData([]);
    } finally {
      setLoadingCity(false);
    }
  }
  useEffect(() => {
    getAllCityAndState();
  }, []);



  //car data
  const [carData, setCarData] = useState([])

  async function getAllCar() {
    try {

      const res = await CargoService.getAllCarType()
      const ids = res?.data?.data?.map((it) => { return it._id })
      const name = res?.data?.data?.map((it) => { return it.label + "-" + it?.name })




      setCarData(ids?.map((it, index) => { return { value: it, label: name[index] } }))

    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    getAllCar();
  }, []);

  const [productData, setProData] = useState([])

  /// all data
  const [allCargos, setAllCargos] = useState([])



  async function getAllCargo() {
    try {

      setLoading(true);

      const res = await CargoService.getAllMyCargo()
      setAllCargos(res?.data?.data)

    } catch (err) {

      console.log(err)
    }
    finally{
      setLoading(false)
    }
  }

  //delete cargo
  async function deleteCargo() {
    setIsDeleting(true)
    try {

      const res = await CargoService.deleteMyCargo({ cargo: idCargo })
      console.log(res)
      if (res.status == 200) {
        getAllCargo()
        dispatch(showToast({ message: "بار شما با موفقیت حذف شد", type: "success" }))
      }

    } catch (err) {
      dispatch(showToast({ message: "خطا در حذف بار", type: "error" }))

      console.log(err)

    } finally {
      setTimeout(() => {
        setDeleteModal(false)
      }, (200));

      setIsDeleting(false)
    }
  }


  // ******************************edit cago
  // origin
  const [originStateId, setOriginStateId] = useState(null);
  const [originDisplay, setOiginDisplay] = useState(null);
  const [originCityId, setOriginCityId] = useState(null);

  // dest
  const [destStateId, setDestStateId] = useState(null);
  const [destDisplay, setDestDisplay] = useState(null);
  const [destCityId, setDestCityId] = useState(null);


  // car / product (id + display)
  const [carId, setCarId] = useState(null);
  const [carDisplay, setCarDisplay] = useState(null);


  //product
  const [productId, setProductId] = useState(null);
  const [productDisplay, setProductDisplay] = useState(null);



  //datet
  const [date, setDate] = useState(null)


  //type
  const [typeDisplay, setTypeDisplay] = useState(null);

  //price
  const [price, setPrice] = useState(null)

  //weight
  const [weightType,setWeightType]=useState(null)
  const [weight, setWeight] = useState(null)

  //description
  const [desc, setDesc] = useState(null)




  function openEditModalWithCargo(cargo) {
    setIdCargo(cargo?._id ?? null);

    // origin
    setOriginStateId(cargo?.origin?.state?._id ?? null);
    setOiginDisplay(cargo?.origin?.state?.name + "-" + cargo?.origin?.name)
    setOriginCityId(cargo?.origin?._id ?? null);

    // dest
    setDestStateId(cargo?.destination?.state?._id ?? null);
    setDestDisplay(cargo?.destination?.state?.name + "-" + cargo?.destination?.name)
    setDestCityId(cargo?.destination?._id ?? null);

    // car/product
    setCarId(cargo?.car?._id ?? null);
    setCarDisplay((carData || []).find((c) => c.value == cargo?.car?._id)?.label ?? null);


    //product
    setProductId(cargo?.product ?? null);
    setProductDisplay((productData || []).find((p) => p.value === cargo?.product?._id)?.label ?? null);


    setPrice(cargo?.price ?? null);
    setDate(cargo.deliveryDate ?? null);
    setWeight(cargo?.weight ?? null);
    setWeightType(cargo?.load_free)
    setDesc(cargo?.description ?? "");

    setTypeDisplay((typeItems || []).find((c) => c.value === cargo?.type)?.label ?? null)

    setOpenEditModal(true);
  }



  async function editMycargo() {
    setLoadingBtn(true)
    try {
      let body;

      if(weightType===true){
        body = {
          "id": idCargo,
          "load_free": weightType,
          "origin": originCityId,
          "description": desc,
          "destination": destCityId,
          "deliveryDate": date,
          "car": carId,
          "price": price,
          "product": productId
        }
      }else{
        body = {
          "id": idCargo,
          "weight": weight,
          "load_free": weightType,
          "origin": originCityId,
          "description": desc,
          "destination": destCityId,
          "deliveryDate": date,
          "car": carId,
          "price": price,
          "product": productId
        }
      }
     
      console.log(body)
      const res = await CargoService.editMyCargo(body)
      console.log(res)
      if (res.status == 200) {
        getAllCargo()
        dispatch(showToast({ message: "بار شما با موفقیت ویرایش شد", type: "success" }))
      }

    } catch (err) {
      dispatch(showToast({ message: "خطا در ویرایش بار", type: "error" }))
      console.log(err)
    } finally {
      setTimeout(() => {
        setOpenEditModal(false)
      }, (200));

      setLoadingBtn(false)
    }
  }


console.log(date)
  useEffect(() => {
    getAllCargo()
  }, [])

  if(loading){
    return(
      <MyLoadsContentSkeleton />
    )
  }

  return (
    <>
      {/* ***********edit modal************* */}
      <EditModal
        loading={loadingBtn}
        isOpen={openEditModal}
        onClose={() => setOpenEditModal(false)}
        onSave={editMycargo}
        title={title}
      >


        {/* cards grid */}
        <motion.div className="grid grid-cols-1 sm:flex sm:flex-wrap gap-8 w-full h-full"
        >

          <CustomInput
            error={(errors.originCity && errors.originState) ? "مبدا انتخاب کنید" : false}
            label="مبدا"
            items={Data}
            setVal={setOriginStateId}
            setSubVal={setOriginCityId}
            val={originDisplay}
            type={"option"}
          />

          <CustomInput
            error={(errors.destState && errors.destCity) ? "مقصد انتخاب کنید" : false}
            label="مقصد"
            items={Data}
            setVal={setDestStateId}
            setSubVal={setDestCityId}
            val={destDisplay}
            type={"option"}
          />

          <CustomInput
            error={errors.car ? "خودرو را انتخاب کنید" : false}
            label="خودرو"
            items={carData}
            setVal={setCarId}
            val={carDisplay}
            type={"option"}
          />

          <CustomInput
            error={errors.product ? "کالا را انتخاب کنید" : false}
            label="محصول ارسالی"
            setVal={setProductId}
            val={productId}
            Placeholder={"نام محصول..."}
          
          />

          <CustomInput

            error={errors.price ? "قیمت را وارد کنید" : false} label="قیمت"
            val={price}
            setVal={setPrice}
            type={"number"} />


          <CustomInput
            error={errors.date ? "تاریخ نمیتواندf خالی باشد" : false}
            val={gregorianToJalali(date)}
            label="تاریخ"
            setVal={setDate}
            type={"date"} />

        <CustomInput
        error={errors.weightType ? "نوع تناژ را انتخاب کنید" : false}
         label="تناژ" 
         items={[{value:true,label:"آزاد"},{value:false,label:"تن"}]} 
         setVal={setWeightType}  
         val={weightType===true ? 'آزاد':'تن'}
         type={"option"} 
         />
         {
          weightType===false &&
          <CustomInput

        error={errors.weight ? "وزن را وارد کنید" : false}
         label="وزن " 
         setVal={setWeight}  
         val={weight}
         type={"number"} 
         unitLabel='تن' />
         }
{/* 
          <CustomInput
            error={errors.weight ? "وزن را وارد کنید" : false}
            label="وزن "
            val={weight}
            setVal={setWeight}
            type={"number"} unitLabel='کیلوگرم' /> */}



          {/* <CustomInput

            error={errors.type ? "نوع بار را انتخاب کنید" : false}
            label="نوع بار"
            items={typeItems}
            val={typeDisplay}
            setVal={setTypeId}
            type={"option"} /> */}



          <CustomInput label="توضیح" val={desc} items={Data} setVal={setDesc} type={"text"} />

        </motion.div>


      </EditModal>


      {/* ***********delete modal************* */}
      <DeleteModal
        title={"آیا از حذف این بار از داشبورد خود اطمینان کامل دارید ؟"}
        open={deleteModal}
        onClose={() => { setDeleteModal(false) }}
        action={deleteCargo}
        isDeleting={isDeleting}
      >
      </DeleteModal>

      {
        allCargos?.length == 0 ?
          <EmptyStateMyLoads

            colorContent="text-special"
            title="باری برای نمایش وجود ندارد"
            subtitle="تاکنون باری ثبت نکرده اید."
            onCta={() => { navigate("/registerCargo") }}
            ctaText="افزودن بار جدید" >

          </EmptyStateMyLoads>
          :
          <div className="flex flex-col items-start justify-start  w-full lg:h-[calc(100vh-10rem)]  overflow-y-auto">
            {
              view === "driver" ?
                <DriverList id={idCargo} setView={setView}></DriverList>
                :
                <>
                  {allCargos?.map((load, index) => {
                    const isExpanded = expanded[load.id];
                    const textLimit = 120;

                    return (

                      <motion.div
                        key={load._id}
                        initial={{ opacity: 0, y: 40 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: index * 0.2 }}
                        className="flex flex-col h-max py-5 lg:px-3 items-start justify-center w-full border-b border-gray-200"
                        dir="rlt"
                      >


                        <p className="text-gray-500 text-[16px] leading-7">
                          تاریخ بارگذاری: {gregorianToJalali(load.deliveryDate)}
                        </p>
                        <p className="text-gray-500 text-[16px] leading-7">
                          خودرو: {load.car?.label + "-" + load.car?.name}
                        </p>

                        <div className="flex flex-row w-full gap-5 items-center justify-start">
                          <p className="text-gray-500 text-[16px] leading-7">
                            مبدا: {load.origin?.state?.name + " , " + load?.origin?.name}
                          </p>
                          <p className="text-gray-500 text-[16px] leading-7">
                            مقصد: {load.destination?.state?.name + " , " + load?.destination?.name}
                          </p>
                        </div>

                        <p className="text-gray-500 text-[16px] leading-7">
                          نوع بار: {load.type === "domestic" ? 'داخلی' : "خارجی"}
                        </p>
                        <p className="text-gray-500 text-[16px] leading-7">
                          قیمت: {load?.price ?
                            `${formatNumberForDisplay(load?.price)} تومان`

                            :
                            "-"
                          }
                        </p>
                        <p className="text-gray-500 text-[16px] leading-7">
                        ایجاد شده در: {gregorianToJalali(load.createdAt)}
                        </p>

                        {/* توضیحات با نمایش بیشتر */}
                        <p className="text-[16px] mt-4 text-gray-900 leading-7 text-right">
                          {
                            load?.description ?
                              isExpanded || load.description?.length <= textLimit
                                ? load.description
                                : load.description?.slice(0, textLimit) + "..."
                              :
                              "بدون توضیحات"


                          }

                        </p>
                        {load.description?.length > textLimit && (
                          <button
                            onClick={() => toggleExpand(load.id)}
                            className="text-blue-600 text-sm mt-1"
                          >
                            {isExpanded ? "نمایش کمتر" : "نمایش بیشتر"}
                          </button>
                        )}

                        {/* دکمه‌ها */}
                        <div className="flex mt-4 flex-row justify-start items-center gap-3 flex-wrap">
                          <motion.button
                            onClick={() => {
                              setView("driver")
                              setIdCargo(load?._id)
                            }}
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.98 }}
                            className="bg-special border border-special px-2 py-2 rounded-lg text-white lg:text-[16px] text-[12px] font-medium transition-colors hover:bg-white hover:text-special"
                          >
                            دیدن لیست راننده‌های متقاضی
                          </motion.button>

                          <motion.button
                            onClick={() => openEditModalWithCargo(load)}
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.98 }}
                            className="bg-white border border-gray-400 px-2 py-2 rounded-lg text-gray-500  lg:text-[16px] text-[12px] font-medium transition-colors hover:bg-gray-100 hover:text-gray-700"
                          >
                            ویرایش بار
                          </motion.button>

                          <motion.button
                            onClick={() => {
                              setDeleteModal(true)
                              setIdCargo(load._id)
                            }}
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.98 }}
                            className="bg-white border border-red-600 px-2 py-2 rounded-lg text-red-600 lg:text-[16px] text-[12px]  font-medium transition-colors hover:bg-red-600 hover:text-white"
                          >
                            حذف آگهی
                          </motion.button>
                        </div>
                      </motion.div>

                    );
                  })}
                </>

            }


          </div>
      }

    </>
  );
}
